import './css/styles.scss';

function faktaRadInit() {}

faktaRadInit();
